import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { Bloom } from './Bloom';
import { packageIncludes } from '../data/site';
export function Pricing() {
  return <section id="pricing" className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-470" data-mp="2ohnxy0txoyjz">
      <Bloom size="lg" className="left-1/2 top-[-16rem] -translate-x-1/2" data-id="element-471" data-mp="2jknrhot69tsc" />

      <div className="mx-auto w-full max-w-3xl px-6 py-20 lg:py-28" data-id="element-472" data-mp="1vtid7e2vr9k5">
        <article className="rounded-3xl border border-emerald-500/40 bg-[#0e1310] p-8 text-center sm:p-12" data-id="element-473" data-mp="1vvv26b722k6p">
          <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500" data-id="element-474" data-mp="25s7wnbafd22i">
            The Complete System
          </h2>

          <p className="mt-8 flex items-baseline justify-center gap-2" data-id="element-475" data-mp="20s3cnbab5p7j">
            <span className="text-5xl font-bold tracking-tight text-white sm:text-6xl" data-id="element-476" data-mp="3h74n8pm9bzbz">
              $1,197
            </span>
            <span className="text-base text-neutral-500" data-id="element-477" data-mp="3c78jmrhh29wy">/month</span>
          </p>
          <p className="mt-4 text-sm text-neutral-400" data-id="element-478" data-mp="3w08dc5xidi9b">
            Month to month. No contracts. We believe in earning it.
          </p>

          <ul className="mx-auto mt-10 grid max-w-xl grid-cols-1 gap-3.5 border-t border-[#1c2420] pt-10 text-left sm:grid-cols-2" data-id="element-479" data-mp="4raznvqr3bsw">
            {packageIncludes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-neutral-300" data-id="element-480" data-mp="eq0jvv64d8cb">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-481" data-mp="3da0e3ywxjbye" />
                {item}
              </li>)}
          </ul>

          <Link to="/contact" className="mt-10 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-[#0a0a0a] transition-colors hover:bg-emerald-400" data-id="element-482" data-mp="3n5u0ea0gajtd">
            Book a 15-min call
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-483" data-mp="2zgr7g60d94jk" />
          </Link>
        </article>

        <div className="mt-8 rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-7" data-id="element-484" data-mp="2rg37ec3e0ero">
          <h3 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-500" data-id="element-485" data-mp="2mibf3gytyqmy">
            Running ads?
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-neutral-400" data-id="element-486" data-mp="315cybomhvre7">
            We manage your Yelp, Google, and Meta campaigns against booked jobs, not clicks. Added
            to your plan with a custom quote based on your budget and platforms.
          </p>
          <Link to="/contact" className="group mt-5 inline-flex items-center gap-2 text-sm font-semibold text-emerald-500 hover:text-emerald-400" data-id="element-487" data-mp="23jfjc17bq470">
            Get a custom quote
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-488" data-mp="2dgtxtv9osiwo" />
          </Link>
        </div>
      </div>
    </section>;
}